// extracted by mini-css-extract-plugin
export default {"container":"_lvvEb8Gp_KXVU2Za3Vz","bordered":"o6tUwGjxaY4KNSEtLhxk","title":"ABR8dF87hH0UZ4d_MzqA","list":"oj0q75ChIlkU8CVbKU37","link":"BDxFmNBHAqRhWbbgXrgh"};